import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer, NodeViewWrapper, NodeViewProps } from "@tiptap/react";
import DatawrapperChartRenderer from "@/components/blog/DatawrapperChartRenderer";

/**
 * Read-only Datawrapper chart node for the PostViewer.
 * Uses DatawrapperChartRenderer for responsive iframe display.
 */
function DatawrapperChartNodeView(props: NodeViewProps) {
  const { node } = props;
  const chartId = node.attrs.chartId as string;
  const className = (node.attrs.class as string) || "media-default";

  return (
    <NodeViewWrapper as="div" className="datawrapper-chart-wrapper">
      <DatawrapperChartRenderer chartId={chartId} className={className} />
    </NodeViewWrapper>
  );
}

export const DatawrapperChartNode = Node.create({
  name: "datawrapper",

  group: "block",

  atom: true,

  draggable: false,

  selectable: false,

  addAttributes() {
    return {
      chartId: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-chart-id"),
        renderHTML: (attributes) => ({
          "data-chart-id": attributes.chartId,
        }),
      },
      class: {
        default: "media-default",
        parseHTML: (element) => element.getAttribute("data-class") || "media-default",
        renderHTML: (attributes) => ({
          "data-class": attributes.class,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="datawrapper"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-type": "datawrapper",
        class: `datawrapper-chart ${HTMLAttributes.class || "media-default"}`,
      }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(DatawrapperChartNodeView);
  },
});

export default DatawrapperChartNode;
